/* email-provider.api — platform and org email provider CRUD */
import { get, post, patch, del } from './client.js';

// Platform-scoped endpoints
export const platform = {
  list:     ()           => get('/platform/email-providers'),
  create:   (body)       => post('/platform/email-providers', body),
  update:   (id, body)   => patch(`/platform/email-providers/${id}`, body),
  remove:   (id)         => del(`/platform/email-providers/${id}`),
  test:       (id)         => post(`/platform/email-providers/${id}/test`, {}),
  activate:   (id)         => post(`/platform/email-providers/${id}/activate`, {}),
  deactivate: (id)         => post(`/platform/email-providers/${id}/deactivate`, {}),
};

// Org-scoped endpoints
export const org = {
  list:     (orgId)           => get(`/orgs/${orgId}/settings/email-providers`),
  create:   (orgId, body)     => post(`/orgs/${orgId}/settings/email-providers`, body),
  update:   (orgId, id, body) => patch(`/orgs/${orgId}/settings/email-providers/${id}`, body),
  remove:   (orgId, id)       => del(`/orgs/${orgId}/settings/email-providers/${id}`),
  test:       (orgId, id)       => post(`/orgs/${orgId}/settings/email-providers/${id}/test`, {}),
  activate:   (orgId, id)       => post(`/orgs/${orgId}/settings/email-providers/${id}/activate`, {}),
  deactivate: (orgId, id)       => post(`/orgs/${orgId}/settings/email-providers/${id}/deactivate`, {}),
};
